const HandleHttpErrors = (errorStatus) => {
  console.log("=================");
  console.log(errorStatus);
  console.log("=================");
  let errorMessage = "";
  switch (errorStatus) {
    case 400:
      return errorStatus + "-" + " חייב תוכן או הרשומה הוגדרה כבר";
    case 401:
      return errorStatus + "-" + "לא בוצעה כניסה למערכת או אין לך הרשאה מתאימה";
    case 403:
      return errorStatus + "-" + "לא בוצעה כניסה למערכת או אין לך הרשאה מתאימה";
    case 500:
      return errorStatus + "-" + "לא ספקת תוכן";
    default:
      return "ErrorFromHandler";
  }
};

export default HandleHttpErrors;
